import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getSortedExceptions } from "store/features/emailScheduler/definition";
import { deleteSchedulerRuleException } from "store/features/emailScheduler/exceptions";
import { getEmailSchedulerExceptionsState } from "store/features/emailScheduler/exceptions";
import { ExceptionTable } from "./ExceptionTable/ExceptionTable";
import { useExceptionDialog } from "components/ExceptionDialog/hooks/useExceptionDialog";
import { ConfirmationDialog, ExceptionDialog } from "components";
import { useConfirmationDialog, useProcessingStatus } from "hooks";

export const ExceptionSection = () => {
    const dispatch = useDispatch();
    const { isDeleting, hasError } = useSelector(getEmailSchedulerExceptionsState);
    const exceptions = useSelector(getSortedExceptions);
    useProcessingStatus(isDeleting, hasError);
    const {
        confirmationId,
        isConfirmationOpen,
        handleOnOpen,
        handleOnClose,
        handleOnExited,
        handleOnConfirm,
    } = useConfirmationDialog((id) => dispatch(deleteSchedulerRuleException.request({ id: id as string })));
    const { t } = useTranslation();
    const { isOpen, handleDialog, handleEditException, handleSubmit } = useExceptionDialog(handleOnClose);

    return (
        <Box mb={4}>
            <Box display="flex" alignItems="flex-end">
                <Box display="flex" mr={2} flex={0.85}>
                    <Typography component="div" variant="subtitle2">
                        <Box fontWeight="fontWeightBold">Exceptions ({exceptions.length})</Box>
                    </Typography>
                </Box>
                <Box display="flex" flex={0.15} justifyContent="flex-end">
                    <Button variant="contained" color="primary" onClick={handleDialog(true)}>
                        {t("buttons.label.addException")}
                    </Button>
                </Box>
            </Box>
            <Box display="flex" mr={2}>
                {exceptions.length > 0 && (
                    <ExceptionTable onExceptionRemove={handleOnOpen} onExceptionEdit={handleEditException} />
                )}
            </Box>
            <ExceptionDialog isOpen={isOpen} onToggle={handleDialog} onSubmit={handleSubmit} />
            <ConfirmationDialog isOpen={isConfirmationOpen} onClose={handleOnConfirm} onExited={handleOnExited}>
                <Typography variant={"body2"}>Do you want do delete &quot;{confirmationId}&quot;?</Typography>
            </ConfirmationDialog>
        </Box>
    );
};
